/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Addressbuilding2Inputs */

const ja_company_companydetails_addressbuilding2 = /** @type {(inputs: Company_Companydetails_Addressbuilding2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`東京都`)
};

const en_company_companydetails_addressbuilding2 = /** @type {(inputs: Company_Companydetails_Addressbuilding2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11F TOC Building`)
};

/**
* | output |
* | --- |
* | "11F TOC Building" |
*
* @param {Company_Companydetails_Addressbuilding2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_addressbuilding2 = /** @type {((inputs?: Company_Companydetails_Addressbuilding2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Addressbuilding2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_addressbuilding2(inputs)
	return en_company_companydetails_addressbuilding2(inputs)
});
export { company_companydetails_addressbuilding2 as "company_companyDetails_addressBuilding" }